import 'react-virtualized/styles.css'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { createBrowserHistory } from 'history'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { hijackEffects } from 'stop-runaway-react-effects'
import { StaticBackend } from 'flag'
import ENV_VARS from '@/config'
import AppContainer from './app'

import { FlagsProvider, flags } from './flags'
import './index.css'
import { unregister as unRegisterServiceWorker } from './registerServiceWorker'
import store from './store'

const container = document.getElementById('root')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript

if (process.env.NODE_ENV === 'development') {
  hijackEffects({ callCount: 350, timeLimit: 500 })
}

const history = createBrowserHistory({ basename: ENV_VARS.APP_PATH })

if (ENV_VARS.BUILD_ENV === 'prod') {
  Sentry.init({
    dsn: 'https://6a9522f9df704f839bc9039b09205576@sentry2.liv.rent/4',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
      })
    ],
    tracesSampleRate: 1.0,
    ignoreErrors: ['ChunkLoadError'],
    allowUrls: [/liv\.rent/],
    denyUrls: [
      /graph\.facebook\.com/i,
      /graph\.facebook\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /js\.api\.here\.com/i,
      /mapsjs-/i
    ]
  })
}

root.render(
  <Provider store={store}>
    <FlagsProvider backend={new StaticBackend(flags)}>
      <Router history={history}>
        <AppContainer />
      </Router>
    </FlagsProvider>
  </Provider>
)

unRegisterServiceWorker()
